export const itemsCounter = [12, 18, 24, 48, 96]
export const defaultItemsCount = 24
